<template>
  <div>
    <v-row>
      <v-col cols="12" md="12">
        <m-form
            :title="title"
            :showList="true"
            :cols="cols"
            @click:row="setItem"
            api-url="main/supplier/all"
            :show-submit-and-clear-btn="false"
            :show-list-btn="false"
            :canDelete="item.id >= 1"
            :items="items"
            :canSubmit="true"
            :isEditing.sync="isEditing"
            :show-navigation-btns="false"
            @submit="submit"
            @delete="deleteItem"
            @clearForm="clearForm()"
            ref="CurrencyForm"
        >
          <template #header-btns>
            <v-spacer></v-spacer>
            <button
                @click="goToProductPage(item.id)"
                v-if="item.id"
                class=" float-left px-3 py-2 text-white py-1 rounded-lg text-[8px] font-bold shadow-md transition-all duration-300 transform hover:scale-105  bg-gradient-to-r from-blue-800 via-blue-900 to-blue-700 hover:bg-[#F17359]"        >
              مشاهده گزارش کمبود موجودی
            </button>
            <button
                @click="goToDashboard(item.id)"
                v-if="item.id"
                class=" float-left px-3 py-2 text-white py-1 rounded-lg text-[8px] font-bold shadow-md transition-all duration-300 transform hover:scale-105  bg-gradient-to-r from-pink-600 via-pink-900 to-pink-800" >
              مشاهده حساب
            </button>
          </template>

          <template>
            <v-row>
              <v-col col="12" md="6">
                <v-text-field label="* نام تامین کننده "
                              v-model="item.name" background-color="white" class="rounded-lg"
                              :disabled="!isEditing" :rules="[rules.required,]"/>

              </v-col>
              <v-col cols="12" md="6">

                <v-text-field class="rounded-lg"  v-on:keydown="NumbersOnly"
                              label="شماره تلفن "
                              v-model="item.phone" background-color="white" :disabled="!isEditing"/>
              </v-col>
              <v-col cols="12" md="4">

                <v-text-field class="rounded-lg"  v-on:keydown="NumbersOnly"
                              label="شماره حساب "
                              v-model="item.bank_account_number" background-color="white" :disabled="!isEditing"/>
              </v-col>
              <v-col cols="12" md="4">
                <cart :rules="[rules.max_cart, rules.min_cart]"
                      v-on:keypress="BankCardValidator"
                      ref="cart"
                      label="* شماره کارت "
                      v-model="item.bank_card_number"
                      :disabled="!isEditing">

                </cart>
              </v-col>
              <v-col cols="12" md="4">
                <cart :rules="[rules.max_sheba, rules.min_sheba]"
                      v-on:keypress="ShebaValidator"
                      ref="sheba"
                      label="شماره شبا" v-model="item.bank_sheba_number"
                      :disabled="!isEditing"
                      append-icon="IR">
                </cart>
              </v-col>
              <v-col col="12" md="12">
                <v-textarea label=" آدرس " rows="2"
                            v-model="item.address" background-color="white" class="rounded-lg"
                            :disabled="!isEditing"/>

              </v-col>
              <v-col col="12" md="12">
                <brand-select v-model="item.brands" :multiple="true" :disabled="!isEditing"></brand-select>
              </v-col>

            </v-row>
          </template>
        </m-form>

      </v-col>
    </v-row>
  </div>

</template>

<script>

import {MFormMixin} from "@/components/m-form";
import FormsMixin from "@/mixin/forms";
import {PathLevels, VisitorLevels} from "@/variables";
import formsMixin from "@/mixin/forms";
import money from "@/components/mcomponents/cleave/Money";
import cart from "@/components/scomponents/Cart";
import UserSelect from "@/components/selects/UserSelect";
import BrandSelect from "@/components/selects/BrandSelect";


export default {
  name: "SupplierForm",
  mixins: [MFormMixin,  formsMixin, FormsMixin],
  components: {
    BrandSelect,
    UserSelect,
    cart
  },

  props: {
    id: {},
  },
  data() {
    return {
      printUrl: 'main/supplier/all',
      baseUrl: "main/supplier",
      permissionBasename: "supplier",
      appendSlash: false,
      hasList: false,
      no_edit_dialog: false,
      hasIdProp: true,
      show_setting: false,
      hasLock: false,
      error_dialog: false,
      error_message: null,
      isDefinable: false,
      myClass: '',
      ss: null,
      PathLevels,
      VisitorLevels,
      paymentDialog: false,
      payment: '',
      performClearForm: true,
      items: [],
      first: false,
      cols: [
        {
          text: "نام",
          value: "name",
        },
      ],

    };
  },
  computed: {
    rules() {
      return {
        max_cart: (v) => v.length <= 19 || "Max 19 characters",
        max_sheba: (v) => v.length <= 29 || "Max 29 characters",
        max_non_iranian_national_code: (v) =>
            v.length <= 12 || "Max 12 characters",
        min_cart: (v) => v.length >= 19 || "Min 19 characters",
        min_sheba: (v) => v.length >= 29 || "Min 29 characters",
        min_non_iranian_national_code: (v) =>
            v.length >= 12 || "Min 12 characters",
      };
    },
    title(){
      return 'تامین کننده'
    },
    headers() {
      return [];
    },
  },
  updated() {
  },
  created() {
  },
  methods: {
    BankCardValidator(evt) {
      if (this.$refs.cart.$props.value.length >= 16) {
        evt.preventDefault();
      }
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
        ;
      } else {
        return true;
      }
    },
    ShebaValidator(evt) {
      if (this.$refs.sheba.$props.value.length >= 24) {
        evt.preventDefault();
      }
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
        ;
      } else {
        return true;
      }
    },
    NumbersOnly(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
        ;
      } else {
        return true;
      }
    },
    goToProductPage(id) {
      this.$router.push(`/panel/supplierLowInventoryByBrand?supplier=${id}`)
    },
    goToDashboard(id) {
      this.$router.push(`/panel/supplierDashboard/${id}`)
    },


  },
}
</script>

<style scoped lang="scss"></style>

